<mat-dialog-content>
  <div class="vital-details-form" *ngIf="vitalForm" [formGroup]="vitalForm">
    <div class="vital-section m-b-10 m-t-10">
      <div class="vital-section__header">
        <h3>Vital Details</h3>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'LABEL.BLOOD_PRESURE_LABEL' | translate }}</mat-label>
            <input matInput placeholder="120/80" formControlName="bloodPressure" maxlength="50">
            <span matSuffix class="vital-unit">mmHg</span>
            <mat-error *ngIf="vitalForm.get('bloodPressure')?.hasError('maxlength')">
              {{ 'REQUIRED.MAXIMUM50' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'LABEL.WEIGHT' | translate }}</mat-label>
            <input matInput type="number" formControlName="weight" min="0" step="any" inputmode="decimal">
            <span matSuffix class="vital-unit">kg</span>
            <mat-error *ngIf="vitalForm.get('weight')?.hasError('min')">
              {{ 'REQUIRED.MINIMUM_WEIGHT' | translate }}
            </mat-error>
          </mat-form-field>

        </div>
        <div class="col-sm-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'LABEL.HEART_RATE' | translate }}</mat-label>
            <input matInput type="text" placeholder="Heart Rate" formControlName="heartRate" min="0">
            <span matSuffix class="vital-unit">bpm</span>
            <mat-error *ngIf="vitalForm.get('heartRate')?.hasError('min')">
              {{ 'VALIDATION.HEART_RATE_MIN' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

      </div>
      <div class="row">
        <div class="col-sm-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'LABEL.OXYGEN_SATURATION' | translate }}(SpO2)</mat-label>
            <input matInput type="text" placeholder="Oxygen Saturation (SpO2)" formControlName="oxygenSaturation" min="0" max="100">
            <span matSuffix class="vital-unit">%</span>
            <mat-error *ngIf="vitalForm.get('oxygenSaturation')?.hasError('min') || vitalForm.get('oxygenSaturation')?.hasError('max')">
              {{ 'VALIDATION.OXYGEN_SATURATION_RANGE' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'LABEL.BODY_TEMPERATURE' | translate }}</mat-label>
            <input matInput type="text" placeholder="Body Temperature" formControlName="bodyTemperature" min="0">
            <span matSuffix class="vital-unit">°C/°F</span>
            <mat-error *ngIf="vitalForm.get('bodyTemperature')?.hasError('min')">
              {{ 'VALIDATION.BODY_TEMPERATURE_MIN' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

    </div>
  </div>
</mat-dialog-content>
<mat-divider *ngIf="showActions && canEdit"></mat-divider>
<mat-dialog-actions class="vital-footer-actions" *ngIf="showActions && canEdit">
  <button mat-flat-button color="primary" type="button" (click)="onSaveVitals()">
    {{ 'BUTTON.BTN_SAVE' | translate }}
  </button>
</mat-dialog-actions>
